import { useEffect } from 'react';

/**
 * Hook to save and restore scroll position for list pages.
 * Saves scroll position to sessionStorage on unmount, restores on mount.
 *
 * @param key - Unique key for this page's scroll position
 */
export function useScrollRestoration(key: string) {
  useEffect(() => {
    // Restore scroll position on mount
    const saved = sessionStorage.getItem(`scroll_${key}`);
    if (saved) {
      // Use requestAnimationFrame to ensure DOM is ready after data loads
      requestAnimationFrame(() => {
        window.scrollTo(0, parseInt(saved, 10));
      });
    }

    // Save scroll position on unmount
    return () => {
      sessionStorage.setItem(`scroll_${key}`, String(window.scrollY));
    };
  }, [key]);
}
